import { Component, OnInit } from '@angular/core';
import { SlideTypeLinesService} from '@app/services/slide-type-lines.service';
import { Router } from '@angular/router';
import {
  listSortIndicator,
  rowMatchesSearch,
  sortRows,
  toggleListSort,
} from '@app/utils/list-table-helpers';

type SlideTypeSortField =
  | 'slideTypeShortcode'
  | 'slideTypeName'
  | 'slidetypeRemarks'
  | 'slideLayoutShortcode';

@Component({
  selector: 'app-slide-type-list',
  templateUrl: './slide-type-list.component.html',
  styleUrl: './slide-type-list.component.scss'
})

export class SlideTypeListComponent implements OnInit {

  slideTypes: any[] = [];
  displayedSlideTypes: any[] = [];
  searchText = '';
  sortField: SlideTypeSortField = 'slideTypeShortcode';
  sortAsc = true;

  constructor(private slideTypeService: SlideTypeLinesService, private router: Router) { }

  ngOnInit() {
    this.loadslideTypes();
  }

  loadslideTypes() {
    this.slideTypeService.getslideTypeList().subscribe((data) => {
      this.slideTypes = Array.isArray(data) ? data : [];
      this.applyFilterAndSort();
    });
  }

  onSearchChange(): void {
    this.applyFilterAndSort();
  }

  setSort(field: SlideTypeSortField): void {
    const next = toggleListSort(this.sortField, field, this.sortAsc);
    this.sortField = next.sortField as SlideTypeSortField;
    this.sortAsc = next.sortAsc;
    this.applyFilterAndSort();
  }

  sortIndicator(field: SlideTypeSortField): string {
    return listSortIndicator(this.sortField, field, this.sortAsc);
  }

  private applyFilterAndSort(): void {
    const q = this.searchText.trim().toLowerCase();
    let rows = this.slideTypes.filter((row) =>
      rowMatchesSearch(row, q, [
        'slideTypeShortcode',
        'slideTypeName',
        'slidetypeRemarks',
        'slideLayoutShortcode',
      ]),
    );
    rows = sortRows(rows, this.sortField, this.sortAsc);
    this.displayedSlideTypes = rows;
  }

  addslideType() {
    this.router.navigate(['/designer/slide-type-form']);
  }

  editslideTypeLines(slideType: any) {
    console.log("In edit slide type lines");
    console.log(slideType);
    let shortcode = slideType.slideTypeShortcode;
    console.log(shortcode);
    this.router.navigate(['/designer/slide-type-lines',shortcode ]);

  }
  
}

